(function() { module.exports = window["wp"]["blockSerializationDefaultParser"]; }());